var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export default function (_a) {
    var env = _a.env, data = _a.data, outputs = _a.outputs, inputs = _a.inputs, onError = _a.onError;
    inputs['params'](function (val, relOutpus) {
        var _a;
        env.collect('设置cookies key: ', data === null || data === void 0 ? void 0 : data.keyName);
        if (data.keyName) {
            if (typeof val === 'string' || typeof val === 'number' || !val) {
                (_a = env.setCookie) === null || _a === void 0 ? void 0 : _a.call(env, data === null || data === void 0 ? void 0 : data.keyName, val, __assign(__assign({ httpOnly: !!data.httpOnly, path: data.path || '/' }, (!!data.maxAge ? {} : { maxAge: data.maxAge })), (!!data.domain ? {} : { domain: data.domain })));
                relOutpus['rtn'](val);
            }
            else {
                onError('设置cookies 入参格式错误');
            }
        }
        else {
            onError('设置cookies 必须配置 key');
        }
    });
}
